import { isDataRangeX } from './type-guards.js';
import type { _XYChartThresholdXStaticData } from '../../types/xy-chart-props.js';

/**
 * Retrieves either the 'xMin' or 'xMax' value from `data` based on `type`,
 * defaulting to `data.x` when the range keys are absent. Mirrors {@link getYValue}
 * for X-axis-bound (vertical) thresholds.
 *
 * @param data - Object containing potential 'xMin', 'xMax', or 'x' properties.
 * @param type - Specifies whether to retrieve 'min' (xMin) or 'max' (xMax).
 * @returns The 'xMin', 'xMax', or 'x' value from the data object.
 */
export const getXValue = (
  data: _XYChartThresholdXStaticData,
  type: 'min' | 'max',
) => {
  const key = type === 'min' ? 'xMin' : 'xMax';
  if (isDataRangeX(data)) {
    return data[key];
  }

  return data.x;
};
